import { CheckInfo } from '@src/types/FmsTypes';
import { Checkbox, Tree } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React, { Key, useEffect } from 'react'
import { IMdMenuDetail } from '../../menu/MenuTypes';
import { IMdResourceDetail } from '../../resource/ResourceTypes';
import { useRoleModel } from '../roleModel';

const { TreeNode } = Tree

interface IDetailResource {
  /** 是否可编辑 */
  checkable: boolean;
}

// 当前资源列表中选中的资源
var selectedArray: Set<string>;

const DetailResouce = (props: IDetailResource) => {
  const { checkable } = props
  const {
    checkedKeys,
    selectedKeys,
    checkedResCodes,
    checkedResDetail,
    indeterminate,
    treeData,
    resourceData,
    checkAll,
    loadResourceByAppAndMenu,
    setSelectedKeys,
    setIndeterminate,
    setCheckedResCodes,
    setCheckAll,
    setCheckedKeys,
    setCheckMenu,
    setResourceData,
    setCheckedResDetail,
  } = useRoleModel()

  // 当资源列表刷新时处理数据
  useEffect(() => {
    // 初始化当前资源列表中已选中的资源表
    let selectedArr = checkedResCodes.filter(v => resourceData.findIndex(item => item.code === v) !== -1)
    selectedArray = new Set(selectedArr)

    // 判断是否已经全选，或者部分选中状态
    if (selectedArr.length === resourceData.length) {
      setIndeterminate(false);
      setCheckAll(true);
    } else if (selectedArr.length > 0) {
      setIndeterminate(true);
      setCheckAll(false);
    } else {
      setIndeterminate(false);
      setCheckAll(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceData])


  /** 菜单选择事件 */
  const onCheck = (checkedKeysValue: Key[], info: CheckInfo<IMdMenuDetail>) => {
    console.log('onCheck', checkedKeysValue, info);
    setCheckedKeys(checkedKeysValue);
    setCheckMenu(info)
    // 当取消菜单绑定时
    if (!info.checked) {
      // 如果当前菜单在选中状态，取消选中，同时清空资源列表
      if (selectedKeys.length > 0 && info?.node?.key === selectedKeys[0]) {
        setSelectedKeys([]);
        setResourceData([])
      }
      // 如果该菜单下有选中的资源，则要清空
      let resDetails = checkedResDetail.filter(item => item.menuCode !== info.node?.key)
      let resCodes = resDetails.map(item => item.code as string)
      setCheckedResCodes(resCodes)
      setCheckedResDetail(resDetails)
    }
  };

  /** 菜单点击事件 */
  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    console.log('onSelect:', selectedKeysValue, info);
    let key = selectedKeysValue[0] as string
    // 点击菜单，判断当前菜单是否已选中，选中则加载菜单的资源，否则清空
    if (info.selected && new Set(checkedKeys).has(key)) {
      setSelectedKeys(selectedKeysValue);
      loadResourceByAppAndMenu(info.node.data.appCode as string, key)
    } else {
      setSelectedKeys([]);
      setResourceData([])
    }
  };


  /** 资源选择事件 */
  const onChange = (e: CheckboxChangeEvent, item: IMdResourceDetail) => {

    let { checked, value } = e.target, checkedValues = new Set(checkedResCodes), checkedDetails = [...checkedResDetail]

    if (checked) {
      checkedValues.add(value)
      selectedArray.add(value)
      checkedDetails.push(item)
    } else {
      checkedValues.delete(value)
      selectedArray.delete(value)
      checkedDetails.filter(res => res.code !== value)
    }

    let checkall = selectedArray.size === resourceData.length
    let indeterminateState = !!selectedArray.size && selectedArray.size < resourceData.length

    setCheckedResCodes(Array.from(checkedValues));
    setCheckedResDetail(checkedDetails)
    setIndeterminate(indeterminateState);
    setCheckAll(checkall);
  };

  /** 资源全选事件 */
  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    let { checked } = e.target
    let selectedArr = new Set(checkedResCodes)

    if (checked) {
      resourceData.forEach(item => {
        selectedArr.add(item.code as string)
        // selectedArray.add(item.value)
      })
    } else {
      resourceData.forEach(item => {
        selectedArr.delete(item.code as string)
        // selectedArray.delete(item.value)
      })
    }

    setCheckedResCodes(Array.from(selectedArr) as string[]);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };


  /** 创建大菜单树 */
  const createTreeNode = (menu: IMdMenuDetail[]) => menu.map(item => {
    if (item.children && item.children.length > 0) {
      return <TreeNode key={item.code} data={item} title={item.name} >
        {createTreeNode(item.children)}
      </TreeNode>
    } else {
      return <TreeNode key={item.code} data={item} title={item.name} />
    }
  })


  return (
    <div className="flex resource-box">
      {/* 左侧菜单树部分 */}
      <div className="flex-1 children-box">
        <Tree
          // defaultExpandAll={true}
          checkable
          onSelect={(keys, info) => checkable ? onSelect(keys, info) : null}
          selectedKeys={selectedKeys}
          onCheck={(checked, info) => checkable ? onCheck(checked as Key[], info) : null}
          checkedKeys={checkedKeys}
        >
          {
            treeData?.map(item => <>
              {/* APP信息 */}
              <TreeNode title={item.appName} className="menuTree-appName" checked={false} disableCheckbox={true} checkable={false} selectable={false} isLeaf={true} />
              {/* Menu Tree */}
              {item.children
                ? createTreeNode(item.children)
                : <TreeNode title="没有菜单" className="nodata-menu" checked={false} disableCheckbox={true} checkable={false} selectable={false} isLeaf={true} />}
            </>)
          }
        </Tree>
      </div>

      {/* 右侧资源部分 */}
      <div
        className="flex-1 children-box"
      >
        {
          <div className="flex-column">
            {
              checkable ?
                // 可编辑资源列表
                resourceData.length > 0 ?
                  <>
                    <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                      全选
                    </Checkbox>
                    {
                      resourceData.map((item, index) => <div key={`check-${index}`}>
                        <Checkbox key={item.code} onChange={e => onChange(e, item)} checked={checkedResCodes.includes(item.code as string)} value={item.code}>{item.name}</Checkbox>
                      </div>)
                    }
                  </>
                  :
                  <div className="nodata-resource">没有资源</div>
                :
                // 不可编辑资源列表
                checkedResDetail.length > 0 ?
                  checkedResDetail?.map(item => <div key={item.key} style={{ padding: '10px 0 0 10px' }}>{item.name}</div>)
                  :
                  <div className="nodata-resource">没有配置资源</div>
            }
          </div>
        }
      </div>
    </div>
  )
}

export default DetailResouce;